export default {
    data() {
        return {
            aletrTimer:''
        }
    },
    alertText (text,width,time) {
        $(".alertText").remove();
        clearTimeout(this.aletrTimer);

        let safeWidth = Number(width);
        if (!isFinite(safeWidth)) {
            safeWidth = 80;
        }
        safeWidth = Math.max(0, Math.min(100, safeWidth));

        let $alert = $('<div>', {
            class: 'alertText app-en ac'
        }).css('width', safeWidth + '%');

        $('<div>', {
            class: 'in'
        }).text(text == null ? '' : String(text)).appendTo($alert);

        $("body").append($alert);
        if(time == undefined){
            time = 2000;
        }
        this.aletrTimer = setTimeout(() => {
            $(".alertText").remove();
        }, time);
    },
	getDate(){
		var aData = new Date();
		//console.log(aData) //Wed Aug 21 2019 10:00:58 GMT+0800 (中国标准时间)
		return  aData.getFullYear() + "/" + (aData.getMonth() + 1) + "/" + aData.getDate();
	}
}



// WEBPACK FOOTER //
// ./src/utils/index.js